import React from 'react';
import TableCompo from '../../components/table/TableCompo';
import useCleanupOnRouteChange from '../../utilities/Cleanup';
import usePaginatedData from '../../utilities/Paginationdata';
const Passenger = () => {
    const {
        data,
        prevData,
        page,
        setPage,
        isLoading,
        message,
        inputValue,
        handleSearch,
        filterValue,
        handleFilter,
    } = usePaginatedData({
        url: `${process.env.REACT_APP_URL}/user/profile/details`,
        localKeys: {
            search: 'search-passenger',
            filter: 'filter-passenger',
            page: 'pageno-passenger',
            totalPage: 'totalpage-passenger',
            totalData: 'totaldata-passenger',
        },
        enableSearch: true,
        enableFilter: false,
    });

    useCleanupOnRouteChange(
        ['search-passenger', 'filter-passenger', 'totalpage-passenger', 'totaldata-passenger', 'pageno-passenger'],
        '/passenger'
    );

    return (
        <TableCompo
            title="Passengers"
            data={data}
            prevData={prevData}
            page={page}
            setPage={setPage}
            isLoading={isLoading}
            message={message}
            search={true}
            view={false}
            pagination={true}
            navPath={'details'}
            handleSearch={handleSearch}
            filter={false}
            inputValue={inputValue}
        />
    );
};

export default Passenger;
